import { render, staticRenderFns } from "./villageInfo.vue?vue&type=template&id=56815962&scoped=true&"
import script from "./villageInfo.vue?vue&type=script&lang=js&"
export * from "./villageInfo.vue?vue&type=script&lang=js&"
import style0 from "./villageInfo.vue?vue&type=style&index=0&id=56815962&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56815962",
  null
  
)

export default component.exports